import { Box, TextField } from '@mui/material';
import { useEffect } from 'react';
import { useFormContext, useController } from 'react-hook-form';
import { IdType } from 'react-table';
import { fixed4Places } from 'shared/utility';
import { FormattedNumber } from './formatted-number';

interface MoneyOrPercentFieldProps<T extends Record<string, any>> {
    original: T;
    index: number;
    id: IdType<T>;
    rules?: Object;
    percent?: boolean;
    section?: string;
}
export function MoneyOrPercentField<T extends Record<string, any>>({
    original,
    index,
    id,
    rules,
    percent,
    section,
}: MoneyOrPercentFieldProps<T>) {
    const { setValue, resetField } = useFormContext();
    const {
        field: { name, onChange, ref, value },
        fieldState: { error, isDirty },
    } = useController({
        name: `${section}.${index}.${id}`,
        rules,
        // rules: {
        //   ...rules,
        //   validate: value => {
        //     const originalValue = Number(original[id]);
        //     let value3X = 0;

        //     switch (true) {
        //       case originalValue > 0:
        //         value3X = fixed4Places(originalValue * 3);
        //         break;
        //       case originalValue < 0:
        //         value3X = fixed4Places(originalValue / 3);
        //         break;
        //       default:
        //         console.log('default')
        //         value3X = fixed4Places(originalValue * 3);
        //         break;
        //     }

        //     console.log({ id, index, originalValue, value, value3X });
        //     return value <= value3X || 'value is 3X greater than the current parameter value';
        //   },
        // },
    });
    const fieldValue = percent ? value * 100 : value;

    useEffect(() => {
        if (isDirty) {
            setValue(`${section}.${index}.lastUpdated`, new Date().toISOString());
        } else {
            resetField(`${section}.${index}.lastUpdated`);
        }
    }, [index, isDirty, section, setValue, resetField, value, original, id]);

    return (
        <Box>
            <FormattedNumber
                id={name}
                displayType='input'
                customInput={TextField}
                onValueChange={v => {
                    const value = v.floatValue || Number(v.value);
                    const newValue = percent ? value / 100 : value;
                    onChange(fixed4Places(newValue));
                }}
                value={fieldValue}
                error={Boolean(error)}
                helperText={error?.message}
                inputRef={ref}
                inputProps={{
                    'aria-label': name,
                }}
                size='small'
                variant='outlined'
                prefix={percent ? undefined : '$'}
                suffix={percent ? '%' : undefined}
                fixedDecimalScale
                sx={{
                    minWidth: 100,
                }}
            />
        </Box>
    );
}
